import createModule from "../createModule"
import view from "./view"
import { Creators } from "./model"
import { Creators as DialogCreators } from "modules/dialog/model"
import { getActiveTab, getSummary, getCoverage, getCoveragePage, getNumberOfTableRows, getSecurities, getSecuritiesPage, getCoverageDate, getCoverageSecurities, getCoverageSecuritiesPage, getUploadOption, getTargetName, getUploadDateTime } from "./selectors"
import { getUntaggedSecurities, getTagRows } from "./selectors/tags"
import { getAttributeRows, getNoAttributeSecurities } from "./selectors/attributes"

export default createModule({
  view,
  mapStateToProps: (state, props) => ({
    activeTab: getActiveTab(state),
    summary: getSummary(state, props),
    coverage: getCoverage(state, props),
    securities: getSecurities(state, props),
    securitiesPage: getSecuritiesPage(state, props),
    coveragePage: getCoveragePage(state),
    coverageDate: getCoverageDate(state),
    uploadOption: getUploadOption(state, props),
    coverageSecurities: getCoverageSecurities(state, props),
    coverageSecuritiesPage: getCoverageSecuritiesPage(state),
    numberOfTableRows: getNumberOfTableRows(state),
    targetName: getTargetName(state, props),
    uploadDateTime: getUploadDateTime(state, props),
    untaggedSecurities: getUntaggedSecurities(state, props),
    tagRows: getTagRows(state, props),
    noAttributesSecurities: getNoAttributeSecurities(state, props),
    attributeRows: getAttributeRows(state, props),
  }),
  actions: {
    ...Creators,
    openDialog: DialogCreators.open,
  },
})
